import React, { memo } from 'react';

const IconLocation = ({ color = "black", ...props }) => (
  <svg {...props} width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M12 21C12 21 18 14.5 18 9C18 5.68629 15.3137 3 12 3C8.68629 3 6 5.68629 6 9C6 14.5 12 21 12 21Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="12" cy="9" r="2.25" stroke={color} strokeWidth="1.5"/>
  </svg>
);

export default memo(IconLocation);
